import {
  AmericanFootballIcon,
  BaseballIcon,
  BasketballIcon,
  CounterStrikeIcon,
  FIFAIcon,
  HandballIcon,
  IceHockeyIcon,
  SportsIcon,
  TableTennisIcon,
  TennisIcon,
  VolleyballIcon,
} from '@repo/icons';
import { memoize } from 'lodash-es';
import { type TranslationType } from '@/lib/types';

interface GamesCategoryItem {
  href: string;
  name: string;
  matches: string[];
  notMatches?: string[];
  Icon: React.FC<{ className?: string }>;
}

export const getSportCategoryItems = memoize(
  (t: TranslationType, eventType: 'live' | 'upcoming', _locale: string) => {
    const type = eventType === 'upcoming' ? `/sportsbook/?prematchSport=` : `/sportsbook/${eventType}/`;

    return [
      {
        Icon: SportsIcon,
        name: t('sport-categories.soccer'),
        href: `${type}soccer-1`,
        matches: [`${type}soccer-1`],
      },
      {
        Icon: BasketballIcon,
        name: t('sport-categories.basketball'),
        href: `${type}basketball-2`,
        matches: [`${type}basketball-2`],
      },
      {
        Icon: TennisIcon,
        name: t('sport-categories.tennis'),
        href: `${type}tennis-5`,
        matches: [`${type}tennis-5`],
      },
      {
        Icon: FIFAIcon,
        name: t('sport-categories.fifa'),
        href: `${type}fifa-300`,
        matches: [`${type}fifa-300`],
      },
      {
        Icon: IceHockeyIcon,
        name: t('sport-categories.ice-hockey'),
        href: `${type}ice-hockey-4`,
        matches: [`${type}ice-hockey-4`],
      },
      {
        Icon: CounterStrikeIcon,
        name: t('sport-categories.counter-strike'),
        href: `${type}counter-strike-109`,
        matches: [`${type}counter-strike-109`],
      },
      {
        Icon: TableTennisIcon,
        name: t('sport-categories.table-tennis'),
        href: `${type}table-tennis-20`,
        matches: [`${type}table-tennis-20`],
      },
      {
        Icon: VolleyballIcon,
        name: t('sport-categories.volleyball'),
        href: `${type}volleyball-23`,
        matches: [`${type}volleyball-23`],
      },
      {
        Icon: BaseballIcon,
        name: t('sport-categories.baseball'),
        href: `${type}baseball-3`,
        matches: [`${type}baseball-3`],
      },
      {
        Icon: HandballIcon,
        name: t('sport-categories.handball'),
        href: `${type}handball-6`,
        matches: [`${type}handball-6`],
      },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.floorball'),
      //   href: `${type}floorball-7`,
      //   matches: [`${type}floorball-7`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.rugby'),
      //   href: `${type}rugby-12`,
      //   matches: [`${type}rugby-12`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.aussie-rules'),
      //   href: `${type}aussie-rules-13`,
      //   matches: [`${type}aussie-rules-13`],
      // },
      {
        Icon: AmericanFootballIcon,
        name: t('sport-categories.american-football'),
        href: `${type}american-football-16`,
        matches: [`${type}american-football-16`],
      },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.snooker'),
      //   href: `${type}snooker-19`,
      //   matches: [`${type}snooker-19`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.darts'),
      //   href: `${type}darts-22`,
      //   matches: [`${type}darts-22`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.gaelic-sports'),
      //   href: `${type}gaelic-sports-27`,
      //   matches: [`${type}gaelic-sports-27`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.rugby-league'),
      //   href: `${type}rugby-league-59`,
      //   matches: [`${type}rugby-league-59`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.league-of-legends'),
      //   href: `${type}league-of-legends-110`,
      //   matches: [`${type}league-of-legends-110`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.starcraft'),
      //   href: `${type}starcraft-112`,
      //   matches: [`${type}starcraft-112`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.call-of-duty'),
      //   href: `${type}call-of-duty-118`,
      //   matches: [`${type}call-of-duty-118`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.warcraft-iii'),
      //   href: `${type}warcraft-iii-122`,
      //   matches: [`${type}warcraft-iii-122`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.rainbow-six'),
      //   href: `${type}rainbow-six-125`,
      //   matches: [`${type}rainbow-six-125`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.esport-fifa'),
      //   href: `${type}esport-fifa-137`,
      //   matches: [`${type}esport-fifa-137`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.esport-valorant'),
      //   href: `${type}esport-valorant-194`,
      //   matches: [`${type}esport-valorant-194`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.wild-rift'),
      //   href: `${type}wild-rift-200`,
      //   matches: [`${type}wild-rift-200`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.mobile-legends'),
      //   href: `${type}mobile-legends-201`,
      //   matches: [`${type}mobile-legends-201`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.cricket-22'),
      //   href: `${type}cricket-22-238`,
      //   matches: [`${type}cricket-22-238`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.nba-2k'),
      //   href: `${type}nba-2k-302`,
      //   matches: [`${type}nba-2k-302`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.etennis'),
      //   href: `${type}etennis-303`,
      //   matches: [`${type}etennis-303`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.ecricket'),
      //   href: `${type}ecricket-305`,
      //   matches: [`${type}ecricket-305`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.eshooter'),
      //   href: `${type}eshooter-308`,
      //   matches: [`${type}eshooter-308`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.fifa-volta'),
      //   href: `${type}fifa-volta-309`,
      //   matches: [`${type}fifa-volta-309`],
      // },
      // {
      //   Icon: SportsIcon,
      //   name: t('sport-categories.estreetball'),
      //   href: `${type}estreetball-314`,
      //   matches: [`${type}estreetball-314`],
      // },
    ] as GamesCategoryItem[];
  },
  (_t, eventType, locale) => JSON.stringify({ eventType, locale })
);
